import axios from 'axios';
import Actions from './actions';
var Creators = Actions.Creators;
var toggleSidenav = Creators.toggleSidenav;
var toggleAccountnav = Creators.toggleAccountnav;
export default {
  toggleSidenav: toggleSidenav,
  toggleAccountnav: toggleAccountnav
};